// extracted by mini-css-extract-plugin
export default {"mapContainer":"Map_mapContainer__cjoG9","invalidPostcode":"Map_invalidPostcode__zc7Xr"};